import React from 'react';
import { DefaultButton, IButtonStyles, IContextualMenuItem, IContextualMenuProps } from '@fluentui/react';
import { Text } from '@fluentui/react/lib/Text';
import './DropdownGroupedItem.css';

export interface IFilterMenuOption {
  key: string;
  text: string;
}

interface IFilterMenuSelector {
  options: IFilterMenuOption[];
  selectedKey: string;
  onChange: (key: string) => void;
}

// Selector con el mismo diseño que ProjectSelector (botón + menú contextual)
export const FilterMenuSelector = (props: IFilterMenuSelector) => {
  const menuProps: IContextualMenuProps = React.useMemo(
      () => ({
        shouldFocusOnMount: true,
        items: props.options.map(
            (option): IContextualMenuItem => ({
              key: option.key,
              text: option.text,
              onRender: (item: any, dismissMenu: (ev?: any, dismissAll?: boolean | undefined) => void) => {
                return (
                    <div
                        onClick={() => {
                          props.onChange(item.key);
                          dismissMenu();
                        }}
                        className="principal-item "
                    >
                      <Text className="d-block">{item.text}</Text>
                    </div>
                );
              },
            })
        ),
      }),
      [props.options, props.onChange]
  );

  const selectedOption = props.options.find((option) => option.key === props.selectedKey);

  const stylesDropdownGroupped: IButtonStyles = {
    root: {
      minWidth: '-webkit-fill-available',
      textAlign: 'left',
      padding: '0px 3px 0px 8px',
      fontWeight: 400,
    },
    label: {
      fontWeight: 400,
      marginLeft: 0,
    },
  };

  return (
      <div>
        <DefaultButton styles={stylesDropdownGroupped} text={selectedOption?.text} menuProps={menuProps} />
      </div>
  );
};
